var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],staticClass:"step-validation",class:_vm.status},[_c('div',{staticClass:"circle"},[_c('i',{staticClass:"banana",class:_vm.icon,attrs:{"aria-hidden":"true"}})]),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }